// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"229":"2e63f43f","444":"d7a0f486","618":"2e63f43f","768":"4e8d1eb1","863":"2b3539c2"}[chunkId] + ".chunk.css";
};